import { ContactsPhoneWUT } from '@wix/form-fields/viewer-wut';

export default ContactsPhoneWUT;
